export default {
  meta: {
    description:
      'Comparing health insurance is a breeze with ahm. Discover different health cover options for singles, couples, families and single parents today.',
    title: 'Join ahm - Browse Policies & Plans',
  },
};
